import { images } from "../constants";

const partners = [
    {
        id: 1, 
        image: images.partner1,
        link: 'https://kongresptp.pl',
    },
    {
        id: 2,
        image: images.partner2,
        link: 'https://www.noweostrowy.pl',
    },
    {
        id: 3,
        image: images.partner3,
        link: 'https://osto.pl',
    },
    {
        id: 4,
        image: images.partner4,
        link: 'https://psych.org.pl',
    },
    {
        id: 5,
        image: images.partner5,
        link: 'https://www.psco.org.pl',
    },
    {
        id: 6,
        image: images.partner6,
        link: 'https://www.sggw.edu.pl',
    },
    {
        id: 7,
        image: images.partner7,
        link: 'https://www.inhort.pl',
    },
    {
        id: 8,
        image: images.partner8,
        link: 'https://biznes-ogrodniczy.pl/',
    },
    {
        id: 9,
        image: images.partner9,
        link: 'https://www.facebook.com/kolejkrosniewice?locale=pl_PL',
    },
    {
        id: 10,
        image: images.partner10,
        link: 'https://cebulki-kwiatowe.pl',
    },
    {
        id: 11,
        image: images.partner11,
        link: 'https://ptchd.org.pl',
    },
    {
        id: 12,
        image: images.partner12,
        link: 'https://kdk.net.pl',
    },
    {
        id: 13,
        image: images.partner13,
        link: 'https://www.radioq.fm/',
    }
];

export default partners;